import React from "react";
import { QrisTransactionDetailResp } from "domain/payload/response/bankamar/QrisTransactionResp";

interface Props {
  item: QrisTransactionDetailResp;
  onClose: () => void;
}

const QrisTransactionDetailModal: React.FC<Props> = ({ item, onClose }) => {
  return (
    <div
      className="modal fade show"
      style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Transaction Detail</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <p><b>ID:</b> {item.id}</p>
            <p><b>Partner Customer ID:</b> {item.partnerCustomerId}</p>
            <p><b>Partner Email:</b> {item.partnerCustomerEmail}</p>
            <p><b>Account Number:</b> {item.accountNumber}</p>
            <p><b>Status:</b> {item.statusCode}</p>
            <p><b>Timestamp:</b> {item.timestamp}</p>
            <hr />
            <p><b>Merchant:</b> {item.transactionData.merchantName}</p>
            <p><b>City:</b> {item.transactionData.merchantCity}</p>
            <p><b>Merchant PAN:</b> {item.transactionData.merchantPan}</p>
            <p><b>Customer PAN:</b> {item.transactionData.customerPan}</p>
            <p><b>Transaction ID:</b> {item.transactionData.transactionID}</p>
            <p><b>Amount:</b> Rp {item.transactionData.amount.toLocaleString()}</p>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QrisTransactionDetailModal;